app.factory('saikuModel', ['$rootScope', 'baseModel', 'saikuService', 'config',
    function($rootScope, baseModel, saikuService, config) {

        function SaikuModel() {
            this.login = function() {
                saikuService.login().then(
                    function (data) {
                        $rootScope.$broadcast(Event.SAIKU.LOGIN.SUCCESS, data);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.SAIKU.LOGIN.ERROR, error);
                    }
                )
            };

            this.getLoggedUser = function() {
                saikuService.getLoggedUser().then(
                    function (data) {
                        $rootScope.$broadcast(Event.SAIKU.GET_LOGGED_USER.SUCCESS, data);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.SAIKU.GET_LOGGED_USER.ERROR, error);
                    }
                )
            };

            this.getRepository = function() {
                saikuService.getRepository().then(
                    function (data) {
                        $rootScope.$broadcast(Event.SAIKU.GET_REPOSITORY.SUCCESS, data);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.SAIKU.GET_REPOSITORY.ERROR, error);
                    }
                )
            };

            this.query = function(uuid, file) {
                saikuService.query(uuid, file).then(
                    function (data) {
                        $rootScope.$broadcast(Event.SAIKU.QUERY.SUCCESS, data);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.SAIKU.QUERY.ERROR, error);
                    }
                )
            };

            this.execute = function(data) {
                saikuService.execute(data).then(
                    function (data) {
                        $rootScope.$broadcast(Event.SAIKU.EXECUTE.SUCCESS, data);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.SAIKU.EXECUTE.ERROR, error);
                    }
                )
            };

            this.downloadPDF = function(uuid, name) {
                if(!name) {
                    name = 'raport';
                }
                window.open(config.SAIKU_URL + '/saiku/api/query/' + uuid + '/export/pdf/flattened?exportname=' + name, '_blank');
            };

            this.generateId = function () {
                function randomString(len, charSet) {
                    charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                    var randomString = '';
                    for (var i = 0; i < len; i++) {
                        var randomPoz = Math.floor(Math.random() * charSet.length);
                        randomString += charSet.substring(randomPoz,randomPoz+1);
                    }
                    return randomString;
                }

                return randomString(10);
            };


        }

        return new SaikuModel();
    }
]);
